import React from "react";
import "../../../../styles/knowledge-concept/quiz/Instructions.css";

const Instructions = ({handleStartQuiz}) => {
  return (
    <div className="instructions-container">
      <div className="instructions-header">
        <h2 style={{ fontWeight: "normal", fontSize: "18px" }}>Quiz: Topic</h2>
      </div>
      <div className="instructions-box">
        <p style={{fontSize:"30px", fontWeight:"bold", alignItems:"center"}}>Instructions</p>
        <div className="scrollable-section">
        <p>Please read the following instructions carefully before starting the quiz:</p>
        <div style={{alignItems:"justifyContent"}}>
        <ol>
      <li><strong>Quiz Format:</strong> The quiz consists of multiple-choice questions. Each question has four answer choices (A, B, C, and D). Only one answer is correct. Some questions may involve calculations, reading passages, or analyzing charts.</li>
      <li><strong>Time Limit:</strong> You will have <strong>30 minutes</strong> to complete the quiz. A timer will be displayed at the top of the screen.</li>
      <li><strong>Navigation:</strong> Use the "Next" button to move to the next question. Use the "Back" button to revisit previous questions. You can skip questions and return to them later if time permits.</li>
      <li><strong>Answer Submission:</strong> To select an answer, click on the corresponding option (A, B, C, or D). Ensure you save your answer before navigating to the next question. Once the time is up, your answers will be automatically submitted.</li>
      <li><strong>Scoring:</strong> Correct answers earn 1 point. There is <strong>no penalty for incorrect answers</strong>, so attempt every question.</li>
      <li><strong>Calculator Use:</strong> For math questions, you are allowed to use an on-screen calculator where indicated. Some math questions must be solved without a calculator.</li>
      <li><strong>Rules and Conduct:</strong> This is a timed, individual quiz. Collaboration with others is not permitted. Refrain from using external resources such as notes, books, or the internet. Maintain academic integrity throughout the quiz.</li>
      <li><strong>Technical Issues:</strong> If you encounter any technical problems, contact the exam proctor immediately. Do not refresh or close the browser during the quiz.</li>
      <li><strong>End of Quiz:</strong> Click "Submit" when you have answered all questions or when you are finished. Ensure you review your answers before final submission.</li>
    </ol>
        </div>
        </div>
        <div className="button-box">
          <button className="start-button" onClick={handleStartQuiz}>Start</button>
        </div>
      </div>
    </div>
  );
};

export default Instructions;
